import { render, staticRenderFns } from "./OfferSummary.vue?vue&type=template&id=c80df65c"
import script from "./OfferSummary.vue?vue&type=script&lang=js"
export * from "./OfferSummary.vue?vue&type=script&lang=js"
import style0 from "./OfferSummary.vue?vue&type=style&index=0&id=c80df65c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports